<template>
    <div class="Ajapp" :style="{ '--divWidth--': divWidth, '--divHeight--': divHeight, }" style="width: var(--divWidth--);height: var(--divHeight--);top: 0;left: 0;z-index: 1 !important;
background-repeat:no-repeat;background-size: var(--divWidth--)  var(--divHeight--);overflow: hidden;">
        <div style="width: 85%;height: 80%;margin: 8% auto 2%;overflow: hidden;">
            <div ref="eCharts" style="width: 100%;height: 100%;overflow: hidden;"></div>
        </div>
        <div class="admin" style="position: fixed;top: 2%;width: 15%;" :style="{ 'right': '-' + nowSize(190) + 'px', }">
            <el-button round style="background-color: rgba(11, 2, 2, 0.5);"
                :style="{ 'marginLeft': nowSize(60) + 'px', }" @click="goToAdmin">活动管理</el-button>
        </div>
        <div class="admin" style="position: fixed;top: 7%;width: 15%;" :style="{ 'right': '-' + nowSize(190) + 'px', }">
            <el-button round style="background-color: rgba(11, 2, 2, 0.5);"
                :style="{ 'marginLeft': nowSize(60) + 'px', }" @click="goToSet">设置</el-button>
        </div>
        <div style="position: fixed;top: 20%;width: 200px;right: 20px;">
            <el-image :src="viteImg" style="width:200px;height:200px;"></el-image>
        </div>
    </div>
</template>
<script>
import echarts from "echarts";
import request from "../../../request";
import {
    getPzVoteRecordRankUser,
} from "../../api/api";
export default {
    name: 'HomePage',
    components: {

    },
    data() {
        return {
            viteImg:require('../../assets/img2026/vote.png'),
            pvmId: '',
            colorArr: ['#409EFF', '#67C23A', '#E6A23C', '#F56C6C', '#e03997', '#f37b1d', '#8dc63f', '#39b54a', '#0081ff', '#6739b6', '#9c26b0', '#a5673f'],
            dataValue: [],
            echartsStr: [],
            dataName: [],
            datalength: 20,
            bg: require('../../assets/img/1.gif'),
            divWidth: '100%',
            divHeight: '100%',
        }
    },
    computed: {

    },
    watch: {
        divWidth(n, v) {
            setTimeout(() => {
                this.echartsStr.resize();
            }, 300)
        }
    },
    activated() {

    },
    mounted() {
        const _this = this;
        window.addEventListener("resize", function () {
            _this.echartsStr.resize();
        })
        // F1 快捷键监听
        window.addEventListener("keydown", function (e) {
            if (e.key === 'F1') {
                e.preventDefault();
                _this.datalength = 3;
                _this.getList();
            }
        })
         // F2 快捷键监听
        window.addEventListener("keydown", function (e) {
            if (e.key === 'F2') {
                e.preventDefault();
                _this.datalength = 20;
                _this.getList();
            }
        })
    },
    created() {
        document.title = '投票排行榜';
        console.log(this.$route.query.pvmId)
        this.pvmId = this.$route.query.pvmId
        if (this.$route.query.pvmId) {
            getPzVoteRecordRankUser({ pvmId: this.$route.query.pvmId }).then(res => {
                this.valueData = res.data;
                res.data.forEach((items, index) => {
                    if (index <= this.datalength - 1) {
                        this.dataName.push(items.name);
                        const s = {
                            value: items.value,
                            itemStyle: {
                                color: this.colorArr[index]
                            }
                        }
                        this.dataValue.push(s);
                    }
                })
                this.DrawEcharts()
            })
        }
        var timer = setInterval(() => {
            setTimeout(() => {
                ///调取接口
                this.dataValue = [],
                    this.dataName = [],
                    getPzVoteRecordRankUser({ pvmId: this.pvmId }).then(res => {
                        this.valueData = res.data;
                        res.data.forEach((items, index) => {
                            if (index <= this.datalength - 1) {
                                this.dataName.push(items.name);
                                const s = {
                                    value: items.value,
                                    itemStyle: {
                                        color: this.colorArr[index]
                                    }
                                }
                                this.dataValue.push(s);
                            }
                        })
                        this.DrawEcharts();
                    })
            }, 0);
        }, 10000);

    },
    methods: {
        getList() {
            this.dataValue = [],
                this.dataName = [],
                getPzVoteRecordRankUser({ pvmId: this.pvmId }).then(res => {
                    this.valueData = res.data;
                    res.data.forEach((items, index) => {
                        if (index <= this.datalength - 1) {
                            this.dataName.push(items.name);
                            const s = {
                                value: items.value,
                                itemStyle: {
                                    color: this.colorArr[index]
                                }
                            }
                            this.dataValue.push(s);
                        }
                    })
                    this.DrawEcharts();
                })
        },
        goToSet() {
            this.$prompt('请输入展示多少个投票项', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
            }).then(({ value }) => {
                if (value > this.valueData.length) {
                    this.$message({
                        type: 'danger',
                        message: '暂时没有这么多投票项'
                    });
                } else {
                    this.datalength = value;
                    this.getList();
                }

            }).catch(() => {

            });
        },
        // 返回活动管理
        goToAdmin() {
            this.$router.replace('/Home')
        },
        // 图标配置项
        DrawEcharts() {
            this.echartsStr = this.$echarts.init(this.$refs.eCharts);

            // 紫色星光渐变系 - 更梦幻的色彩
            const getBarColor = (index) => {
                const colors = [
                    new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        { offset: 0, color: '#F472B6' }, // 浅粉
                        { offset: 0.5, color: '#C084FC' }, // 紫粉
                        { offset: 1, color: '#A855F7' } // 紫色
                    ]),
                    new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        { offset: 0, color: '#67E8F9' }, // 天蓝
                        { offset: 0.5, color: '#22D3EE' }, // 青色
                        { offset: 1, color: '#06B6D4' } // 蓝色
                    ]),
                    new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        { offset: 0, color: '#FDE68A' }, // 浅黄
                        { offset: 0.5, color: '#FCD34D' }, // 黄色
                        { offset: 1, color: '#F59E0B' } // 橙黄
                    ]),
                    new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        { offset: 0, color: '#A78BFA' }, // 浅紫
                        { offset: 0.5, color: '#8B5CF6' }, // 紫色
                        { offset: 1, color: '#7C3AED' } // 深紫
                    ]),
                    new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        { offset: 0, color: '#6EE7B7' }, // 浅绿
                        { offset: 0.5, color: '#34D399' }, // 绿色
                        { offset: 1, color: '#10B981' } // 深绿
                    ]),
                    new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        { offset: 0, color: '#F9A8D4' }, // 粉红
                        { offset: 0.5, color: '#F472B6' }, // 粉色
                        { offset: 1, color: '#EC4899' } // 深粉
                    ]),
                ];
                return colors[index % colors.length];
            };

            this.echartsStr.setOption({
                tooltip: {
                    show: false
                },
                grid: {
                    top: '8%',
                    bottom: '5%',
                    left: '2%',
                    right: '2%',
                    containLabel: false
                },
                xAxis: {
                    type: 'category',
                    data: this.dataName,
                    show: false,
                    axisLine: { show: false },
                    axisTick: { show: false },
                    axisLabel: { show: false }
                },
                yAxis: {
                    type: 'value',
                    show: false,
                    splitLine: { show: false }
                },
                series: [
                    {
                        data: this.dataValue.map((item, index) => ({
                            value: item.value,
                            itemStyle: {
                                color: getBarColor(index),
                                borderRadius: [this.nowSize(25), this.nowSize(25), this.nowSize(10), this.nowSize(10)]
                            }
                        })),
                        type: 'bar',
                        barWidth: '50%',
                        barMaxWidth: this.nowSize(100),
                        label: {
                            show: true,
                            position: 'inside',
                            align: 'center',
                            formatter: (params) => {
                                // 根据柱子数量动态计算每行可显示的字符数
                                const total = this.dataValue.length;
                                const chartWidth = document.documentElement.clientWidth;
                                const barWidth = (chartWidth * 0.96 * 0.5) / total; // 估算柱子宽度
                                const charWidth = this.nowSize(12);
                                const padding = this.nowSize(10);
                                const maxChars = Math.floor((barWidth - padding) / charWidth);
                                const safeChars = Math.max(3, Math.min(6, maxChars)); // 3-6个字符

                                const name = params.name;
                                let nameHtml = '';
                                if (name.length > safeChars) {
                                    const rows = Math.ceil(name.length / safeChars);
                                    for (let i = 0; i < rows; i++) {
                                        const start = i * safeChars;
                                        const end = Math.min(start + safeChars, name.length);
                                        nameHtml += `{name|${name.substring(start, end)}${end < name.length ? '\n' : ''}}`;
                                    }
                                } else {
                                    nameHtml = `{name|${name}}`;
                                }
                                return `${nameHtml}\n{space|}\n{value|${params.value.toLocaleString()}}\n{unit|票}`;
                            },
                            rich: {
                                name: {
                                    color: '#fff',
                                    fontSize: this.nowSize(14),
                                    fontWeight: 'bold',
                                    textShadow: '0 0 8px rgba(0,0,0,0.8)',
                                    lineHeight: this.nowSize(18),
                                    align: 'center'
                                },
                                space: {
                                    height: this.nowSize(8)
                                },
                                value: {
                                    color: '#fff',
                                    fontSize: this.nowSize(20),
                                    fontWeight: 'bold',
                                    textShadow: '0 0 10px rgba(192, 132, 252, 0.9)',
                                    align: 'center'
                                },
                                unit: {
                                    color: 'rgba(255,255,255,0.75)',
                                    fontSize: this.nowSize(11),
                                    textShadow: '0 0 4px rgba(0,0,0,0.5)',
                                    align: 'center'
                                }
                            }
                        },
                        itemStyle: {
                            shadowBlur: this.nowSize(35),
                            shadowColor: 'rgba(192, 132, 252, 0.6)'
                        },
                        animationDuration: 1200,
                        animationEasing: 'elasticOut',
                        animationDelay: (idx) => idx * 100,
                        emphasis: {
                            itemStyle: {
                                shadowBlur: this.nowSize(60),
                                shadowColor: 'rgba(244, 114, 182, 0.9)'
                            }
                        }
                    }
                ]
            })
        },
        //  换算方法
        nowSize(val, initWidth = 1920) {
            //当前视口宽度
            let nowClientWidth = document.documentElement.clientWidth;
            return val * (nowClientWidth / initWidth);
        }
    }
}
</script>

<style scoped>
.diaZj::-webkit-scrollbar {
    display: none;
}

.admin:hover {
    right: 1% !important;
    width: auto !important;
}

.diaBg {
    background-image: url(../../assets/img/bg3.jpg) !important;
    background-repeat: no-repeat;
    background-size: 100% 100%;
}

.diaBg2 {
    background-image: url(../../assets/img/mingdanBg.png) !important;
    background-repeat: no-repeat;
    background-size: 100% 100%;
}

.Ajapp {
    background-image: url(../../assets/img2026/bg_vote.jpg) !important;
    height: 100vh;
}

.ajMain {
    display: flex;
    height: 80%;
    width: 90%;
    justify-content: space-between;
    margin: 8% auto;
    overflow: hidden;
}

.leftDiv {
    width: 25%;
    background-image: url(../../assets/img/left.png) !important;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    height: 100%;
}

.centenDiv {
    width: 75%;
    background-image: url(../../assets/img/mingdanBg.png) !important;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    height: 100%;
}

.rightDiv {
    width: 18%;
    margin-left: 2%;
    background-image: url(../../assets/img/right.png) !important;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    height: 100%;
}

.handImg {
    background-image: url(../../assets/img/hand.png) !important;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: relative;
}

.handImgto {
    position: absolute;
    top: 0;
    left: 0;
    content: "";
    width: 100%;
    height: 100%;
    background: url(../../assets/img/headquan.png) no-repeat !important;
    background-size: 100% 100% !important;
    -webkit-animation: rotateAnimation 2.5s infinite linear;
    animation: rotateAnimation 2.5s infinite linear;
    transform-origin: center !important;
}

@keyframes rotateAnimation {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }


}
</style>
